export function isFullWidth(lenke) {
  return lenke.visning === 'vertikal-dobbel' || lenke.visning === 'horisontal'
}

export function isVideo(lenke) {
  return lenke.url.includes('https://www.nrk.no/video')
}

export function hasSecondaryLayout(lenke) {
  return (
    lenke.url.includes('http://p3.no') ||
    lenke.url.includes('https://radio.nrk.no') ||
    lenke.url.includes('https://tv.nrk.no')
  )
}
